import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  bulkResultModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  headerTopSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  bulkResultModalContent: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 15px 50px rgba(0, 0, 0, 0.3)",
    width: "98vw",
    padding: "24px",
    maxWidth: "1800px",
    maxHeight: "95vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "1px solid #e0e0e0"
  },
  bulkModalHeader: {
    padding: "20px 0px",
    borderBottom: "1px solid #e0e0e0"
  },
  bulkModalHeaderLeft: {
    flex: 1
  },
  bulkModalTitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#2c3e50",
    margin: 0,
    lineHeight: 1.3
  },
  bulkModalSubtitle: {
    fontSize: "14px",
    color: "#666",
    marginTop: "4px"
  },
  closeButton: {
    color: "#666",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    borderRadius: "8px",
    padding: "8px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  },
  bulkModalBody: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  },
  bulkControls: {
    padding: "20px 0px",
    // borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    flexShrink: 0,
    "& .MuiGrid-container": {
      alignItems: "center"
    },
    "& .select-group": {
      marginBottom: 0
    },
    "& label": {
      fontSize: "13px",
      fontWeight: "600",
      marginBottom: "6px"
    },
    "& select": {
      padding: "10px 12px",
      fontSize: "14px",
      borderRadius: "8px",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      width: "100%",
      "&:focus": {
        outline: "none",
        borderColor: "#3498db",
        boxShadow: "0 0 0 2px rgba(52, 152, 219, 0.2)"
      }
    }
  },
  bulkTableContainer: {
    flex: 1,
    overflow: "auto",
    backgroundColor: "#f5f7fa",
    border: "1px solid #dfe1e5",
    borderRadius: "8px"
  },
  bulkTable: {
    backgroundColor: "#fff",
    borderRadius: 0
  },
  bulkHeaderCell: {
    backgroundColor: "#2c3e50",
    color: "#fff",
    fontWeight: "600",
    fontSize: "14px",
    // padding: "12px 8px",
    width: "15px",
    position: "sticky",
    top: 0,
    zIndex: 11,
    borderBottom: "2px solid #1a252f",
    textAlign: "center",
    verticalAlign: "middle"
  },
  bulkSubHeaderCell: {
    backgroundColor: "#34495e",
    color: "#fff",
    fontWeight: "500",
    fontSize: "12px",
    padding: "8px 6px",
    position: "sticky",
    top: "48px",
    zIndex: 11,
    borderBottom: "2px solid #1a252f",
    textAlign: "center",
    verticalAlign: "middle"
  },
  caHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2px"
  },
  caMaxScore: {
    fontSize: "10px",
    color: "#ecf0f1",
    opacity: 0.8,
    fontWeight: "400"
  },
  bulkStudentCell: {
    padding: "10px 12px !important",
    fontWeight: "500",
    fontSize: "13px",
    borderRight: "2px solid #e0e0e0 !important"
  },
  bulkCell: {
    padding: "6px 4px !important",
    verticalAlign: "middle",
    backgroundColor: "inherit",
    width: "10px",
    "& .input-group": {
      marginBottom: 0
    }
  },
  pendingCell: {
    backgroundColor: "#fff3cd !important",
    borderLeft: "3px solid #ffc107 !important"
  },
  totalCell: {
    padding: "6px 4px !important",
    verticalAlign: "middle",
    fontWeight: "600",
    fontSize: "13px"
  },
  totalDisplay: {
    padding: "8px 6px",
    textAlign: "center",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  gradeCell: {
    padding: "6px 4px !important",
    verticalAlign: "middle",
    fontWeight: "700",
    fontSize: "14px"
  },
  gradeDisplay: {
    padding: "8px 6px",
    textAlign: "center",
    backgroundColor: "#e8f5e9",
    borderRadius: "6px",
    border: "1px solid #c8e6c9",
    color: "#2e7d32",
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  studentNameCell: {
    padding: "10px 12px !important",
    fontWeight: "500",
    fontSize: "13px",
    borderRight: "2px solid #e0e0e0 !important"
  },

  courseInfo: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    fontSize: "14px",
    color: "#546e7a"
  },

  infoItem: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    "& strong": {
      color: "#37474f",
      marginRight: "4px"
    }
  },
  statsGrid: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    alignItems: "center"
  },
  searchContainer: {
    position: "relative",
    // display: "flex",
    alignItems: "center",
    marginTop: "32px",
    "& svg": {
      marginTop: "10px"
    }
  },

  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: "#546e7a"
  },
  inputContainer: {
    position: "relative",
    width: "100%"
  },
  scoreInput: {
    "& .input-group-container": {
      marginBottom: 0
    },
    "& input": {
      width: "100%",
      minWidth: "60px",
      padding: "8px 6px",
      textAlign: "center",
      fontSize: "13px",
      borderRadius: "6px",
      border: "1px solid #f1f1f1ff",
      backgroundColor: "#fff",
      "&:focus": {
        outline: "none",
        borderColor: "#3498db",
        boxShadow: "0 0 0 2px rgba(52, 152, 219, 0.2)"
      },
      "&:disabled": {
        backgroundColor: "#f5f5f5",
        cursor: "not-allowed"
      }
    }
  },
  scoreInputField: {
    textAlign: "center !important",
    padding: "8px 6px !important",
    height: "36px !important"
  },
  calculatedValue: {
    width: "100%",
    padding: "8px 6px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "500",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  totalValue: {
    backgroundColor: "#e8f4fd",
    borderColor: "#c5e1f7",
    color: "#2c3e50",
    fontWeight: "600"
  },
  gradeValue: {
    backgroundColor: "#e8f5e9",
    borderColor: "#c8e6c9",
    color: "#2e7d32",
    fontWeight: "700",
    fontSize: "14px"
  },
  bulkRowEven: {
    backgroundColor: "#fff",
    "&:hover": {
      backgroundColor: "#f9f9f9"
    }
  },
  bulkRowOdd: {
    backgroundColor: "#f8f9fa",
    "&:hover": {
      backgroundColor: "#f1f3f4"
    }
  },
  bulkModalFooter: {
    padding: "16px 0px",
    // borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // backgroundColor: "#f8f9fa",
    flexShrink: 0
  },
  bulkStats: {
    display: "flex",
    gap: "16px",
    fontSize: "13px",
    color: "#666",
    "& span": {
      padding: "6px 12px",
      backgroundColor: "#fff",
      borderRadius: "6px",
      fontWeight: "500",
      border: "1px solid #e0e0e0",
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
    }
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    "& button": {
      minWidth: "140px"
    }
  },
  cancelButton: {
    borderColor: "#ddd",
    color: "#666",
    "&:hover": {
      backgroundColor: "#f5f5f5"
    }
  },
  errorTooltip: {
    backgroundColor: "#e74c3c",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "500",
    padding: "8px 12px",
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(231, 76, 60, 0.3)",
    maxWidth: "200px"
  },
  errorTooltipArrow: {
    color: "#e74c3c"
  },
  // Responsive styles
  "@media (max-width: 1200px)": {
    bulkResultModalContent: {
      width: "95vw",
      margin: "20px auto",
      maxHeight: "95vh",
      overflowY: "auto",
      display: "block",
      padding: "16px"
    },
    bulkModalBody: {
      display: "block",
      overflow: "visible",
      flex: "none",
      height: "auto"
    },
    bulkTableContainer: {
      padding: 0,
      display: "block",
      overflow: "auto",
      maxHeight: "400px",
      minHeight: "250px",
      flex: "none"
    },
    bulkControls: {
      padding: "16px 0px"
    },
    bulkModalHeader: {
      padding: "16px 0px"
    },
    bulkModalFooter: {
      padding: "16px 0px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px"
    }
  },
  "@media (max-width: 768px)": {
    bulkResultModalContent: {
      width: "95vw",
      margin: "10px auto",
      maxHeight: "92vh",
      padding: "12px"
    },
    bulkTableContainer: {
      maxHeight: "320px",
      minHeight: "200px"
    },
    bulkModalTitle: {
      fontSize: "20px"
    },
    bulkControls: {
      "& .MuiGrid-container": {
        flexDirection: "column",
        gap: "12px"
      },
      "& .MuiGrid-item": {
        width: "100%"
      }
    },
    bulkStats: {
      flexDirection: "column",
      gap: "8px"
    },
    actionButtons: {
      flexDirection: "column",
      width: "100%",
      "& button": {
        width: "100%"
      }
    }
  },
  // Results
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "4px",
    marginTop: "28px"
  },

  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",

    '& input[type="checkbox"]': {
      width: "16px",
      height: "16px",
      cursor: "pointer"
    }
  },

  checkboxHint: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: "#666",

    "&.has-results": {
      color: "#1976d2"
    },

    "&.no-results": {
      color: "#f44336"
    }
  }

}));

export default useStyles;
